export const REQUESTED_BENEFICIARIES = 'REQUESTED_BENEFICIARIES';
export const requestedBeneficiaries = () => ({
  type: REQUESTED_BENEFICIARIES
});

export const RECEIVED_BENEFICIARIES = 'RECEIVED_BENEFICIARIES';
export const receivedBeneficiaries = (beneficiaries) => ({
  type: RECEIVED_BENEFICIARIES,
  beneficiaries
});

export const ERROR_BENEFICIARIES = 'ERROR_BENEFICIARIES';
export const errorBeneficiaries = (error) => ({
  type: ERROR_BENEFICIARIES,
  error
});

export const REQUESTED_UPDATE_BENEFICIARIES = 'REQUESTED_UPDATE_BENEFICIARIES';
export const requestedUpdateBeneficiaries = () => ({
  type: REQUESTED_UPDATE_BENEFICIARIES
});

export const RECEIVED_UPDATE_BENEFICIARIES = 'RECEIVED_UPDATE_BENEFICIARIES';
export const receivedUpdateBeneficiaries = (benes,actionType,beneficiaries) => ({
  type: RECEIVED_UPDATE_BENEFICIARIES,
  actionType: actionType,
  beneficiaries
});

export const ERROR_UPDATE_BENEFICIARIES = 'ERROR_UPDATE_BENEFICIARIES';
export const errorUpdateBeneficiaries = (error,beneficiaries) => ({
  type: ERROR_UPDATE_BENEFICIARIES,
  beneficiaries
});

export const UPDATE_BENE_EDIT = 'UPDATE_BENE_EDIT';
export const updateBeneEditFlag = (value) => ({
  type: UPDATE_BENE_EDIT,
  value
});
export const SET_FIELD = 'SET_FIELD';
export const setField = (field, value) => {
  const payload = { field, value };
  return {
    type: SET_FIELD,
    payload: payload,
  };
};
export const ADD_TO_BENEFICIARIESV2_LIST = 'ADD_TO_BENEFICIARIESV2_LIST';
export const addbeneficiaryListV2 = (payload) => {
  return {
    type: ADD_TO_BENEFICIARIESV2_LIST,
    payload
  };
};

export const RESET_BENEFICIARIES_CONTEXT = 'RESET_BENEFICIARIES_CONTEXT';
export const resetBeneficiariesContext = () => ({
  type: RESET_BENEFICIARIES_CONTEXT
});

export const UPDATE_MANAGED_BENEFICIARY = 'UPDATE_MANAGED_BENEFICIARY';

export const updateBeneficiary = (selectedBeneficiaryId, updatedBeneficiary) => ({
  type: UPDATE_MANAGED_BENEFICIARY,
  payload: { selectedBeneficiaryId, updatedBeneficiary }
});

export const SET_MANAGE_BENEFICIARIES = 'SET_MANAGE_BENEFICIARIES';
export const updateManageBeneficiaries = (beneficiaries) => ({
  type: SET_MANAGE_BENEFICIARIES,
  payload: beneficiaries
});
export const SET_AGREEMENTS_BENEFICIARIES = 'SET_AGREEMENTS_BENEFICIARIES';
export const updateAgreementsForBeneficiaries = (beneficiaries) => ({
  type: SET_AGREEMENTS_BENEFICIARIES,
  payload: beneficiaries
});

export const PUSH_NEW_BENEFICIARY = 'PUSH_NEW_BENEFICIARY';

export const pushNewBeneficiary = (newBeneficiary) => ({
  type: PUSH_NEW_BENEFICIARY,
  payload: newBeneficiary
});


